import { Component, ChangeDetectionStrategy } from '@angular/core';
import { BaseModalComponent } from '../../../../ui-components/modal/base-modal-component';
import { SharedModule } from '../../../../ui-components/shared.module';
import { CloseBtnComponent } from '../../../../@components/close-btn/close-btn.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'vw-ai-chatbot-info-modal',
    imports: [SharedModule, CloseBtnComponent, TranslatePipe],
    templateUrl: './ai-chatbot-info-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './ai-chatbot-info-modal.component.scss'
})
export class AiChatbotInfoModalComponent extends BaseModalComponent {
  constructor() {
    super();
  }

}
